module.exports = __webpack_public_path__ + "img/icon-excel.009be9d5.svg";